import { ReactNode } from "react";
import * as React from "react";

import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { createStyles, Divider, Group, Text } from "@mantine/core";

const useStyles = createStyles({
  ellipsisText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

export const PropertyCard = ({
  icon,
  label,
  value,
  withDivider = true,
  hidden = false,
}: {
  icon: ReactNode;
  label: string;
  value: ReactNode;
  withDivider?: boolean;
  hidden?: boolean;
}) => {
  const { classes } = useStyles();
  if (hidden) return <></>;
  return (
    <>
      {withDivider && <Divider />}
      <Group position="apart">
        <Group align="center" spacing={10}>
          {icon}
          <Text size="sm">{label}</Text>
        </Group>
        <Text
          size="sm"
          color={TEXT_COLOR.SECONDARY}
          className={classes.ellipsisText}
        >
          {value}
        </Text>
      </Group>
    </>
  );
};
